require('public/css/catalog.scss');

const partTypeFilterHelpers = require('public/templates/modules/part_type_filter/utils');
var isLoadingFacetsCatalog = false;

const { trackCategoryListEvent } = require('public/js/lib/adobe-dtm-helper');
let searchFacetParams = [];
const catalog = {
	getCategoryId: function () {
		return parseInt(rp$('.catalog-products').data('category'));
	},
};

catalog.getAvailableSearchFacetQueryNames = function() {
	const facets = Array.from(
		document.querySelectorAll('.search-facets-module .facet-wrapper')
	);

	return facets.map((facet) => facet.getAttribute('data-query-name'));
};

catalog.getSearchResultsCatalog = function (changedField, params) {
	let historyUrl = null;
	if (changedField !== 'history') {
		historyUrl = catalog.buildHistoryUrl(params);
	}

	if (window.__DISABLE_SEARCH_HISTORY_HANDLER) {
		rp_app.location.redirect(historyUrl);
		return;
	}

	rp$(document).trigger('searchResults:request');
	$ajax({
		method: 'GET',
		dataType: 'json',
		data: params,
		url: catalog.buildFetchUrl(),
		error: (/*j, textStatus, error*/) => {
			rp$(document).trigger('searchResults:error');
		},
		success: (response/*, status, xhr*/) => {
			if (historyUrl !== null) {
				try {
					window.history.pushState({}, '', historyUrl);
				}
				catch (e) {/* TODO: For now, ignoring IE9 and below.. revisit when we do full filtering sidebar */ }
			}

			rp$(document).trigger('searchResults:response', response);
		},
		complete: () => {
			isLoadingFacetsCatalog = false;
		}
	});
};

const groupAndSubgroup = window.location.pathname.split('/')[2];
if (groupAndSubgroup) {
	catalog.groupAndSubgroup = groupAndSubgroup;
}

catalog.buildFetchUrl = function () {
	catalog.type = catalog.getCategoryId() ? 'catalog-c' : 'refresh-assemblies';
	switch (catalog.type) {
		case 'refresh-assemblies':
			return `/ajax/oem-assemblies-search/${this.groupAndSubgroup}`;
		case 'catalog-c':
			return `/ajax/catalog/c-${catalog.getCategoryId()}`;
		default:
			return `/ajax/catalog/c-${catalog.getCategoryId()}`;
	}
};

catalog.buildHistoryUrl = function (requestParams) {
	let baseUrl = rp$('base').attr('href');
	if (!baseUrl || typeof baseUrl === 'string') {
		baseUrl = rp_app.location.getBase();
	}
	const currentPath = rp_app.location.pathname.replace(/^\//, '');
	const targetParams = rp$.extend(rp_app.query.all(), requestParams);
	delete targetParams['identifier'];
	delete targetParams['use_cfc'];

	return baseUrl + '/' + currentPath + '?' + rp$.param(targetParams);
};

catalog.handleHistoryChange = function (/*evt*/) {
	const args = rp_app.query.all(rp_app.location.href);
	const params = {
		page: args.page,
	};

	catalog.getSearchResultsCatalog('history', params);
};

catalog.handlePageChange = function (pageNum) {
	const args = rp_app.query.all(rp_app.location.href);
	const partTypeFilters = partTypeFilterHelpers.getAdditionalFilterValuesFromDom();

	const params = {
		page: pageNum,
		...partTypeFilters
	};
	searchFacetParams.forEach((facet) => {
		if (args[facet]) {
			params[facet] = decodeURIComponent(args[facet]);
		}
	});
	catalog.getSearchResultsCatalog('page', params);
};

if (!window.__DISABLE_SEARCH_HISTORY_HANDLER) {
	window.addEventListener('popstate', catalog.handleHistoryChange);

	rp$(document).off('searchResults:pageChange');
	rp$(document).on('searchResults:pageChange', function handlePageChange(evt, pageNum) {
		evt.preventDefault();
		catalog.handlePageChange(pageNum);
	});
}

catalog.prepareCatalog = function () {
	searchFacetParams = catalog.getAvailableSearchFacetQueryNames();
	const productRows = rp$('.catalog-product.marketplace-product');
	// Track Adobe DTM category page view
	if (productRows.length) {
		trackCategoryListEvent();
	}

	const $partTypeFilter = rp$('.part-type-filter-form');
	if ($partTypeFilter.length > 0) {
		$partTypeFilter.on('changeAdditionalFilters', function handleAdditionalFilterChange(evt, filters) {
			catalog.type = 'catalog-c';
			catalog.getSearchResultsCatalog('', filters);
		});
	}

	const $facetsModule = rp$('.search-facets-module');
	if ($facetsModule.length > 0) {
		$facetsModule.on('selectedFacetBucketsChanged', function handleSelectedBucketsChange(e, queryParams) {
			catalog.type = catalog.getCategoryId() ? 'catalog-c' : 'refresh-assemblies';
			// Factor existing vehicle filter params into search
			const partTypeFilters = partTypeFilterHelpers.getAdditionalFilterValuesFromDom();
			const updatedParams = { ...queryParams, ...partTypeFilters };
			if(!isLoadingFacetsCatalog) {
				isLoadingFacetsCatalog = true;
				catalog.getSearchResultsCatalog('', updatedParams);
			}
		});
	}
};

module.exports = catalog;